import script from "D:\\Kryzalis\\mpardini.com.br\\src\\assets\\js\\components\\BtnWhatsapp\\BtnWhatsappFixo.vue?type=script"
export * from "D:\\Kryzalis\\mpardini.com.br\\src\\assets\\js\\components\\BtnWhatsapp\\BtnWhatsappFixo.vue?type=script"
export default script